module.exports = __webpack_public_path__ + "static/media/Vijaya.438fcc68.ttf";